export enum LocalStorageKey {
    guestUserCache = 'guestUserCache',
    systemPropertyCache = 'systemPropertyCache',
    selectedPreferredLandingPage = 'selectedPreferredLandingPage',
    companyName = 'companyName',
    selectedFilter = 'selectedFilter',
    staffingFundFamilyFilter = 'staffingFundFamilyFilter',
    staffingStatusFilter = 'staffingStatusFilter',
    metricCodeCache = 'metricCodeCache'
}
